import React from 'react';
import { Outlet } from 'react-router';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './life-area-detail.style';
import { OutletContext } from './outlet-context';

export const LifeAreaDetail: React.FC = () => {
  const mainScrollRef = React.useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Main ref={mainScrollRef}>
        <PageTopBar />

        <Outlet context={{ mainScrollRef } satisfies OutletContext} />
      </Styled.Main>
    </Styled.Container>
  );
};
